// @flow
let localStorage;

if (window) {
  ({ localStorage } = require('@rover/utilities/storage'));
}

const checkEnvironment = () => {
  if (!localStorage) throw new Error('Tried to call localStorage outside of a browser.');
};

export const getItem = (key: string) => {
  checkEnvironment();
  return localStorage.getItem(key);
};

export const setItem = (key: string, value: string) => {
  checkEnvironment();
  return localStorage.setItem(key, value);
};

export const removeItem = (key: string) => {
  checkEnvironment();
  return localStorage.removeItem(key);
};

export const clear = () => {
  checkEnvironment();
  return localStorage.clear();
};



// WEBPACK FOOTER //
// ../react-lib/src/apis/localStorage.api.js